import BatchType from "../../../types/Batch";
import generateType from "../../batches/components/generateType";
import { BATCH_STATUS } from "../../batches/components/FilteringBatchesDialog";
import { pushToHistory } from "../../../tools/batchHistory";

export const recordBatchInHistory = (
  batchId: number,
  userId?: string | number | null
) => {
  if (userId != null) {
    pushToHistory(batchId, String(userId));
  }
};

export const isAdminLabelingRole = (userRole?: string | null) =>
  userRole === "ROLE_ADMIN" || userRole === "ROLE_PROJECT_ADMIN";

export const canLabelizeBatch = (
  batch: BatchType,
  userRole?: string | null
) => {
  const isAdminRole = isAdminLabelingRole(userRole);
  return (
    batch.state === BATCH_STATUS.NOT_STARTED.name ||
    batch.state === BATCH_STATUS.IN_PROGRESS.name ||
    batch.state === BATCH_STATUS.TO_BE_CORRECTED.name ||
    (isAdminRole && batch.state === BATCH_STATUS.COMPLETED.name)
  );
};

export const getLabelerPath = (batch: BatchType) => {
  const type = generateType(batch);
  const lastLabeledImage =
    batch.totalLabelDocs < batch.totalEligibleDocs
      ? batch.totalLabelDocs
      : 0;
  return `/labeler${type}/${batch.id}/${lastLabeledImage}`;
};

const LABELING_TYPE_LABELS: Record<string, string> = {
  VIDEO: "VIDEO",
  RECTANGLE_BOXING: "RECTANGLE BOXING",
  PLATE: "PLATE",
  PLATE_TEXT: "PLATE TEXT",
  CLASSIF: "CLASSIFICATION",
  SEGMENTATION: "SEGMENTATION",
};

export const formatLabelingType = (labelingType?: string | null) => {
  if (!labelingType) return "inconnu";
  return LABELING_TYPE_LABELS[labelingType] || labelingType;
};

export const getBatchLabelingType = (batch: BatchType) =>
  batch.project?.labelingTypes?.[0]?.name ?? "";
